// components
import { ExtendFile } from './types';

// ----------------------------------------------------------------------

// Define more types here
const FORMAT_PDF = ['pdf'];
const FORMAT_TEXT = ['txt'];
const FORMAT_PHOTOSHOP = ['psd'];
const FORMAT_WORD = ['doc', 'docx'];
const FORMAT_EXCEL = ['xls', 'xlsx', 'tsv', 'csv', 'numbers'];
const FORMAT_ZIP = ['zip', 'rar', 'iso'];
const FORMAT_ILLUSTRATOR = ['ai', 'esp'];
const FORMAT_POWERPOINT = ['ppt', 'pptx'];
const FORMAT_AUDIO = ['wav', 'aif', 'mp3', 'aac'];
const FORMAT_IMG = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'svg'];
const FORMAT_VIDEO = ['m4v', 'avi', 'mpg', 'mp4', 'webm'];

const iconUrl = (icon: string) => `/assets/icons/files/${icon}.svg`;

// ----------------------------------------------------------------------

export function fileFormat(extension: string) {
  let currentExtension = extension.toLowerCase();
  let format;

  if (FORMAT_TEXT.includes(currentExtension)) {
    format = 'txt';
  }

  if (FORMAT_ZIP.includes(currentExtension)) {
    format = 'zip';
  }
  if (FORMAT_AUDIO.includes(currentExtension)) {
    format = 'audio';
  }
  if (FORMAT_IMG.includes(currentExtension)) {
    format = 'image';
  }

  if (FORMAT_VIDEO.includes(currentExtension)) {
    format = 'video';
  }

  if (FORMAT_WORD.includes(currentExtension)) {
    format = 'word';
  }
  if (FORMAT_EXCEL.includes(currentExtension)) {
    format = 'excel';
  }

  if (FORMAT_POWERPOINT.includes(currentExtension)) {
    format = 'powerpoint';
  }

  if (FORMAT_PDF.includes(currentExtension)) {
    format = 'pdf';
  }
  if (FORMAT_PHOTOSHOP.includes(currentExtension)) {
    format = 'photoshop';
  }
  if (FORMAT_ILLUSTRATOR.includes(currentExtension)) {
    format = 'illustrator';
  }

  return format;
}

// ----------------------------------------------------------------------

export function fileThumb(format: string) {
  let thumb;

  switch (format) {
    case 'folder':
      thumb = iconUrl('ic_folder');
      break;
    case 'txt':
      thumb = iconUrl('ic_txt');
      break;
    case 'zip':
      thumb = iconUrl('ic_zip');
      break;
    case 'audio':
      thumb = iconUrl('ic_audio');
      break;
    case 'video':
      thumb = iconUrl('ic_video');
      break;
    case 'word':
      thumb = iconUrl('ic_word');
      break;
    case 'excel':
      thumb = iconUrl('ic_excel');
      break;
    case 'powerpoint':
      thumb = iconUrl('ic_power_point');
      break;
    case 'pdf':
      thumb = iconUrl('ic_pdf');
      break;
    case 'photoshop':
      thumb = iconUrl('ic_pts');
      break;
    case 'illustrator':
      thumb = iconUrl('ic_ai');
      break;
    case 'image':
      thumb = iconUrl('ic_img');
      break;
    default:
      thumb = iconUrl('ic_file');
  }
  return thumb;
}

// ----------------------------------------------------------------------

export function fileTypeByUrl(fileUrl = '') {
  return (fileUrl && fileUrl.split('.').pop()) || '';
}

// ----------------------------------------------------------------------

export function fileNameByUrl(fileUrl: string) {
  return fileUrl.split('/').pop();
}

// ----------------------------------------------------------------------

export function fileData(file: ExtendFile | string) {
  // Url
  if (typeof file === 'string') {
    return {
      key: file,
      preview: file,
      name: fileNameByUrl(file),
      type: fileTypeByUrl(file),
    };
  }

  // File
  return {
    key: file.preview,
    name: file.name,
    size: file.size,
    path: file.path,
    type: file.type,
    preview: file.preview,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
  };
}
